const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

export const extractSubdomainFromHostname = (): string | null => {
  const cleanHostname = hostname.split(':')[0];

  const parts = cleanHostname.split('.');

  // If we have more than 2 parts, the first one is likely a subdomain
  // Examples: stanford.localhost:4000, harvard.goalsetter.co
  if (parts.length > 2) {
    return parts[0];
  }

  // Special case for localhost with subdomain (development)
  if (parts.length === 2 && parts[1] === 'localhost') {
    return parts[0];
  }

  // Special case for production domains with subdomain
  // Examples: stanford.goalsetter.co, harvard.goalsetter.com
  if (
    parts.length === 2 &&
    (parts[1] === 'goalsetter.co' || parts[1] === 'goalsetter.com')
  ) {
    return parts[0];
  }

  return null;
};

//TODO: This is a temporary function to get the URL with the subdomain. We need to use useClientConfig hook instead CHECK
export const getURLWithSubdomain = (url: string): string => {
  const subdomain = extractSubdomainFromHostname();

  if (!subdomain || url.includes(`${subdomain}.`)) {
    return url;
  }

  if (url.startsWith('http://')) {
    return url.replace('http://', `http://${subdomain}.`);
  }

  if (url.startsWith('https://')) {
    return url.replace('https://', `https://${subdomain}.`);
  }

  return `${subdomain}.${url}`;
};

/**
 * Normalizes a URL to be absolute by prepending https:// if it's missing a protocol.
 * This ensures URLs from the backend are treated as absolute URLs rather than relative paths.
 *
 * @param url - The URL to normalize (may be undefined)
 * @returns The normalized URL with protocol, or undefined if input was undefined
 *
 * @example
 * normalizeUrl("example.com/path") // returns "https://example.com/path"
 * normalizeUrl("https://example.com/path") // returns "https://example.com/path" (unchanged)
 * normalizeUrl(undefined) // returns undefined
 */
export const normalizeUrl = (url: string | undefined): string | undefined => {
  if (!url) {
    return undefined;
  }
  // If the URL already starts with http:// or https://, return as-is
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  // Otherwise, prepend https:// to make it an absolute URL
  return `https://${url}`;
};
